import React from "react";
import AssignmentRules from "../../modules/assignmentRules";

const AssignmentRulesPage = () => {
  return <AssignmentRules />;
};

export default AssignmentRulesPage;
